import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'sondermind-icon-loader',
  template: `
    <ng-container *ngIf='loading; then spinnerTpl; else iconTpl'>
    </ng-container>
    <ng-template #spinnerTpl>
      <mat-spinner></mat-spinner>
    </ng-template>
    <ng-template #iconTpl>
      <mat-icon [inline]="inline">{{ icon }}</mat-icon>
    </ng-template>`,
  standalone: false
})
export class IconLoaderComponent {
  @HostBinding('class.sondermind-icon-loader')
    bindClass = true;

  @Input()
    loading: boolean;

  @Input()
    icon: string;

  @Input()
    inline = false;
}
